import React from "react";
import moment from "moment";
import classnames from "classnames";
import Select from "react-select";
import DateTimePicker from "../DateTimePicker";
import TimePicker from "../TimePicker";
import Firebase from "../../firebasehelper";
import "./index.css";

const Styles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    width: 300,
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: 14,
    width: 300,
  }),
};

class NewOffer extends React.Component {
  state = {
    selectedRetailer: null,
    attentionGrabber: "",
    postNow: true,
    scheduledDate: moment(),
    uploading: false,
    hot_topic_tags:[],
    hot_topic:null
  };
  componentDidMount(){
    const {brand_name} = this.props;
    if(brand_name)
      Firebase.getAllHotTopics(brand_name,hot_topics=>{
        let hot_topic_tags =  hot_topics.map(topic=>{
          let label = `${(topic.starting_monday.toDate()).toLocaleDateString("en-US", { month: 'long', day: 'numeric' })} - ${topic.tag}`;
          let value = topic.id;
          return {label,value}
        });
        console.log("hot_topic_tags",hot_topic_tags);
        this.setState({hot_topic_tags});
      });
  }
  componentDidUpdate(prevProps) {
    
    if (prevProps.selectedDate !== this.props.selectedDate) {
      this.setState({ postNow: true }, () => {
        this.setState({
          postNow: false,
          scheduledDate: this.props.selectedDate,
        });
      });
      const {brand_name} = this.props;
      console.log("brand_name",brand_name);
      if(brand_name)
        Firebase.getAllHotTopics(brand_name,hot_topics=>{
          let hot_topic_tags =  hot_topics.map(topic=>{
            let label = `${(topic.starting_monday.toDate()).toLocaleDateString("en-US", { month: 'long', day: 'numeric' })} - ${topic.tag}`;
            let value = topic.id;
            return {label,value}
          });
          console.log("hot_topic_tags",hot_topic_tags);
          this.setState({hot_topic_tags});
        });
    }
  }

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onChangeScheduledDate = (value) => {
    this.setState({
      scheduledDate: value,
    });
  };

  onChangeTime = obj => {
    const {scheduledDate} = this.state;
    const {hh,mm,of} = obj;
    let hours = hh;
    let newMoment = moment(scheduledDate);
    if (of==="pm" && hh !== 12) hours = hh + 12;
    newMoment.set('hour',hours);
    newMoment.set('minute',mm);
    this.setState({scheduledDate:newMoment});
  }

  handleRetailerChanged = (newValue) => {
    this.setState({
      selectedRetailer: newValue,
    });
  };

  handlePostNowChanged = (value) => () => {
    this.setState({
      postNow: value,
    });
  };

  isPostable = ()=>{
    const { selectedRetailer, attentionGrabber,postNow,scheduledDate } = this.state;
    const timeValuable = postNow?true:scheduledDate.isAfter(moment(new Date()));
    const isPostable = selectedRetailer && attentionGrabber && timeValuable;
    return isPostable;
  }

  post = async () => {
    const {
      selectedRetailer,
      attentionGrabber,
      hot_topic,
      postNow,
      scheduledDate,
    } = this.state;

    this.setState({ uploading: true });
    try {
      if (this.props.onAdd) {
        let error = await this.props.onAdd({
          retailer: selectedRetailer,
          attentionGrabber,
          hot_topic:hot_topic?hot_topic.value:null,
          postNow: this.props.selectedDate ? false : postNow,
          scheduledDate: scheduledDate,
        });
        if (!error) {
          this.setState({
            selectedRetailer: null,
            attentionGrabber: "",
            postNow: true,
            scheduledDate: moment(),
            uploading: false,
          });
        }
      }
    } catch (e) {
      console.log("adding offer error", e);
    }

    this.setState({ uploading: false });
  };

  render() {
    const {
      selectedRetailer,
      attentionGrabber,
      uploading,
      postNow,
      scheduledDate,
      hot_topic_tags,
      hot_topic
    } = this.state;
    const { selectedDate, retailers } = this.props;
    let options = retailers.filter(retailer=>retailer.ecopayRetailer)
    .sort((a, b) => a.retailerName.localeCompare(b.retailerName))
    .map((obj) => ({
      label: obj.retailerName,
      value: obj.retailerName,
    }));
    return (
      <div className="new-offer-container">
        <p className="section-title">Select retailer</p>
        <Select
          value={selectedRetailer}
          onChange={this.handleRetailerChanged}
          options={options}
        />
        <p className="section-title">Add an attention grabber</p>
        <textarea
          type="text"
          name="attentionGrabber"
          className="form-control form-control-lg form-control-alt"
          onChange={this.onChange}
          value={attentionGrabber}
          placeholder="Type your content here..."
        />
        {hot_topic_tags.length>0&&<div className="form-group" style={{marginTop:30,width:500}}>
              <Select
                isSearchable={true}
                value={hot_topic}
                onChange={(e) => {
                  const {label,value} = e;
                  this.setState({ hot_topic: {label,value}});
                }}
                options={[{label:"None",value:null},...hot_topic_tags]}
                placeholder="Select a hot topic tag"
                styles={Styles}
              ></Select>
        </div>}
        <p className="schedule-title">
          {!selectedDate && (
            <React.Fragment>
              <b>Post now</b> or{" "}
            </React.Fragment>
          )}
          <b>Schedule</b>
        </p>
        {!selectedDate && (
          <div className="schdule-now-container">
            <div
              className={classnames("check-box", {
                checked: postNow,
              })}
              onClick={this.handlePostNowChanged(true)}
              style={{
                marginLeft: "20px",
              }}
            ></div>
            <div
              className={classnames("check-box", {
                checked: !postNow,
              })}
              onClick={this.handlePostNowChanged(false)}
              style={{
                marginLeft: "80px",
              }}
            ></div>
          </div>
        )}
        {selectedDate&&<React.Fragment>
              <p className="feed-schedule-time">{scheduledDate.format('LLL')}</p>
              <TimePicker onChange={this.onChangeTime}/>
          </React.Fragment>}
        {!postNow && !this.props.selectedDate&&(
            <DateTimePicker onTimeChange={this.onChangeScheduledDate}/>                  
        )}
        {uploading && <i className="fa fa-4x fa-sync fa-spin text-muted" />}
        {!uploading && (
          <button
            className="btn btn-primary post black-text-btn"
            onClick={this.post}
            disabled={!this.isPostable()}
          >
            Post
          </button>
        )}
      </div>
    );
  }
}

export default NewOffer;



// WEBPACK FOOTER //
// ./src/components/NewOffer/index.js